import * as Yup from "yup";
import { useState } from "react";
import { Formik, Form } from "formik";
import Toaster from "../../../../Toast/Toast";
import { useDispatch, useSelector } from "react-redux";
import TextInput from "../../../../TextInput/TextInput";
import { Deposit } from "../../../../../api/modules/b2droppie.class";
import BackdropLoader from "../../../../BackdropLoader/BackdropLoader";
import { togglePayment } from "../../../../../redux/slices/accountSlice";
import {
  paymentSuccess,
  setPaymentType,
} from "../../../../../redux/slices/paymentSlice";
import { trackDepositSubmit } from "../../../../../utils/GoogleTagTracking";
import {ReactComponent as WalletIcon} from "../../../../../assets/icons/walletIcon.svg";
const DepositTab = () => {
  const dispatch = useDispatch();
  const [usdValue, setUsdValue] = useState(10);
  const [isLoading, setLoading] = useState(false);
  const initialValues = { coinAmount: usdValue || "" };
  const [toastMessage, setToastMessage] = useState(null);
  const isDarkMode = useSelector((state) => state.theme.darkMode);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const DepositSchema = Yup.object().shape({
    coinAmount: Yup.number()
      .typeError("Amount must be a number")
      .required("Amount is required")
      .min(10, "Amount must be at least 10 USD")
      .max(500000, "Amount must not exceed 500000 USD"),
  });

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await Deposit({
        price_currency: "usd",
        price_amount: usdValue,
      });
      if (res?.data?.data?.url) {
        dispatch(paymentSuccess(res?.data?.data));
        trackDepositSubmit();
        dispatch(setPaymentType("Payment"));
        dispatch(togglePayment());
      }
    } catch (err) {
      console.error(err);
      setToastMessage({ error: "Deposit failed. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Toaster message={toastMessage} />
      <div className="depositnewbtn-main px-2 px-md-4">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={DepositSchema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, touched, handleSubmit, setFieldValue }) => (
            <Form>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "flex-start",
                  marginBottom: "24px",
                }}
              >
                <div style={{ flexShrink: 0, alignSelf: "center" }}>
                  <WalletIcon
                    style={{ width: 40, height: 40, color: "#facc15" }}
                  />
                </div>

                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={{
                      fontSize: "24px",
                      fontWeight: 600,
                      color: "white",
                    }}
                  >
                    Deposit
                  </span>
                  <span style={{ fontSize: "14px", color: "#9ca3af" }}>
                    Refill the Wallet
                  </span>
                </div>
              </div>{" "}
              <span
                className="mt-3 text-fw-500"
                style={{ color: isDarkMode ? "#808080" : "black" }}
              >
                Amount
              </span>
              <TextInput
                min="10"
                type="number"
                name="coinAmount"
                placeholder="USD"
                max="999999999999999"
                value={values.coinAmount}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  setFieldValue("coinAmount", e.target.value);
                  setUsdValue(isNaN(value) ? 0 : value);
                }}
                className={`w-100 deposit-modal-input ${
                  isDarkMode ? "formInputDark" : "formInput"
                }`}
              />
              <div className="d-flex flex-column">
                <span className="error">
                  {errors.coinAmount && touched.coinAmount && errors.coinAmount}
                </span>

                <span
                  className="my-4 px-2 text-16px text-fw-500 text-new-order"
                  style={{ color: "#E6261F" }}
                >
                  Please double-check the deposit amount and destination address
                  before proceeding. Sending funds to an incorrect address may
                  result in permanent loss and cannot be reversed. A 2%
                  processing fee will be applied to this transaction.
                </span>
              </div>
              <div className="d-end mt-1">
                <div className="d-end w-lg-50 w-md-100 gap-10px">
                  <button
                    type="button"
                    disabled={isLoading}
                    ref={(el) => {
                      if (el && isMobile) {
                        el.style.setProperty("height", "56px", "important");
                      }
                    }}
                    onClick={() => dispatch(togglePayment())}
                    className={`w-30 w-md-100 text-18px text-fw-700 pt-2 ${
                      isDarkMode
                        ? "deep-primary-monochrome-btn-dark"
                        : "outlined-medium-deep-purple-btn-light"
                    } ${isLoading ? "cursor-disabled" : ""}`}
                  >
                    <span>Cancel</span>
                  </button>
                  <button
                    type="button"
                    disabled={isLoading}
                    onClick={handleSubmit}
                    ref={(el) => {
                      if (el && isMobile) {
                        el.style.setProperty("height", "56px", "important");
                      }
                    }}
                    className={`w-30 w-md-100 text-18px text-fw-700 pt-10px ${
                      isDarkMode
                        ? "filled-medium-deep-yellow-btn-dark"
                        : "filled-medium-deep-purple-btn-light"
                    } ${isLoading ? "cursor-disabled" : ""}`}
                  >
                    <span className="deposit-text">Deposit ${usdValue}</span>
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <BackdropLoader show={isLoading} />
    </>
  );
};

export default DepositTab;
